import { Tag, TagLabel, TagLeftIcon, TagRightIcon } from '@chakra-ui/react';
export const CUITag = Tag;
export const CUITagLabel = TagLabel;
export const CUITagLeftIcon = TagLeftIcon;
export const CUITagRightIcon = TagRightIcon;